module.exports = __webpack_public_path__ + "img/mobile-hk.2f8fab33.jpg";